import './legend.scss'
import React from 'react'

// Draws a legend from lib/layerLegend's legendForDisplay: a swatch and a label per entry,
// or a one-line "■ label" when there's a single entry.

const MarkerShape = ({ marker, fill, stroke }) => {
  const props = { fill, stroke: stroke || 'none', strokeWidth: stroke ? 1 : 0 }
  switch (marker) {
    case 'square': return <rect x="2" y="2" width="10" height="10" {...props} />
    case 'triangle': return <polygon points="7,1.5 12.5,12 1.5,12" {...props} />
    case 'diamond': return <polygon points="7,1 13,7 7,13 1,7" {...props} />
    default: return <circle cx="7" cy="7" r="5" {...props} />
  }
}

// A colour as a background image, so the square's light ground shows through its opacity.
const asImage = bg => (!bg || bg === 'transparent' ? undefined
  : bg.includes('gradient(') ? bg : `linear-gradient(${bg}, ${bg})`)

export const Swatch = ({ swatch }) => {
  switch (swatch.shape) {
    case 'line':
      return (
        <svg className="layer-legend__swatch is-line" viewBox="0 0 22 14" aria-hidden="true">
          {swatch.casing && <line x1="1" y1="7" x2="21" y2="7" stroke={swatch.casing} strokeWidth={swatch.width + 2} strokeLinecap="round" />}
          <line x1="1" y1="7" x2="21" y2="7" stroke={swatch.color} strokeWidth={swatch.width}
            strokeDasharray={swatch.dashed ? '4 3' : undefined} strokeLinecap={swatch.dashed ? 'butt' : 'round'} />
        </svg>
      )
    case 'marker':
      return (
        <svg className="layer-legend__swatch" viewBox="0 0 14 14" aria-hidden="true">
          <MarkerShape marker={swatch.marker} fill={swatch.background} stroke={swatch.stroke} />
        </svg>
      )
    case 'dot':
      return <span className="layer-legend__swatch is-dot" style={{ background: swatch.background }} aria-hidden="true" />
    default:
      return <span className={`layer-legend__swatch is-square${swatch.hollow ? ' is-hollow' : ''}`} aria-hidden="true"
        style={{ backgroundImage: asImage(swatch.background), border: swatch.border || undefined }} />
  }
}

const Ramp = ({ ramp }) => (
  <li className="layer-legend__ramp">
    {ramp.title && <div className="layer-legend__ramp-title">{ramp.title}</div>}
    <div className="layer-legend__ramp-bar" style={{ background: ramp.gradient }} />
    <div className="layer-legend__ramp-labels">
      {ramp.stops.filter(s => s.label).map((s, i) => (
        <span key={i} style={{ left: `${s.at * 100}%` }}
          className={s.at <= 0 ? 'is-start' : s.at >= 1 ? 'is-end' : undefined}>{s.label}</span>
      ))}
    </div>
  </li>
)

const LayerLegend = ({ legend }) => {
  if (!legend) return null
  const { single, swatches } = legend
  return (
    <div className="layer-legend">
      {single ? (
        <div className="layer-legend__single">
          <Swatch swatch={swatches[0]} />
          <span>{swatches[0].label}</span>
        </div>
      ) : (
        <ul className="layer-legend__entries">
          {swatches.map((s, i) => s.shape === 'ramp'
            ? <Ramp key={i} ramp={s} />
            : <li key={i}><Swatch swatch={s} /><span>{s.label}</span></li>)}
        </ul>
      )}
    </div>
  )
}

export default LayerLegend
